import { render, staticRenderFns } from "./PrivateBox.vue?vue&type=template&id=35569b02&scoped=true&"
import script from "./PrivateBox.vue?vue&type=script&lang=js&"
export * from "./PrivateBox.vue?vue&type=script&lang=js&"
import style0 from "./PrivateBox.vue?vue&type=style&index=0&id=35569b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35569b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35569b02')) {
      api.createRecord('35569b02', component.options)
    } else {
      api.reload('35569b02', component.options)
    }
    module.hot.accept("./PrivateBox.vue?vue&type=template&id=35569b02&scoped=true&", function () {
      api.rerender('35569b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivateBox.vue"
export default component.exports